import { Form, FormItem } from '@/components';
import styled from 'styled-components';

export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

export const StyledFormItem = styled(FormItem)`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  margin-bottom: 0;

  label {
    font-weight: 700;
  }

  .ant-form-item-row {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
  }

  .ant-form-item-control,
  .ant-form-item-control-input,
  .ant-form-item-control-input-content {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  textarea {
    flex: 1;
    width: 100%;
    height: 100%;
    resize: none;
    overflow-y: auto;
  }
`;
